<template>
  <div class="container">
    <div class="report-orgs-title">
      <span>{{ props.title }}</span>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';
const props = defineProps({
  title: {
    type: String,
    required: true
  }
});
</script>
<style lang="scss" scoped>
.report-orgs-title {
  position: relative;
  margin: 80px 0 60px;
  // background: repeat-x center
  //   url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='9' height='20'%3E%3Cpath fill-rule='evenodd' fill='%2398BDFC' d='M9.776 19.672V.231h1.505v19.441H9.776zM5.224.231h1.505v19.441H5.224V.231zm-4.552 0h1.506v19.441H.672V.231z'/%3E%3C/svg%3E");
  color: #407bee;
  font-size: 32px;
  font-weight: bold;
  text-align: center;
  border-top: 2px solid #6ba9e6;
  vertical-align: top;
  span {
    position: absolute;
    left: 50%;
    top: 50%;
    // width: 450px;
    transform: translate(-50%, -50%);
    background: #fff;
    // padding: 0 10px;
    min-width: 320px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &::before,
    &::after {
      // display: inline-block;
      width: 20px;
      height: 20px;
      margin: 0 20px;
      background: #fff url('../../imgs/jt_right.png') no-repeat;
      background-size: cover;
      content: '';
    }
    &::before {
      transform: rotate(180deg);
    }
  }
}
</style>
